import { useRef, useState } from 'react';
import { getMediaType } from '../utils';

type Params = {
  isLoading: boolean;
  onError: (message: string) => void;
};

export const useFileStaging = ({ isLoading, onError }: Params) => {
  const [stagedFile, setStagedFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const stageFile = (rawFile: File) => {
    if (isLoading) return;
    const mediaType = getMediaType(rawFile);
    if (!mediaType) {
      setStagedFile(null);
      onError('Unsupported file type. Please upload a PDF.');
      return;
    }
    setStagedFile(rawFile);
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isLoading) return;
    const file = e.target.files?.[0];
    if (file) stageFile(file);
    e.target.value = '';
  };

  return {
    stagedFile,
    setStagedFile,
    stageFile,
    handleFileInputChange,
    fileInputRef,
  };
};
